// src/features/owner/OwnerSidebar.tsx — grouped owner nav (Dashboard + 4 groups). Mirrors SettingsSidebar.
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Icon } from '@/icons';
import { LogoTriad } from '@/icons/brand/LogoTriad';
import { OWNER_GROUPS, OWNER_SECTIONS } from '@/core/data/owner-sections';

const Aside = styled.nav` display:flex; flex-direction:column; gap:4px; height:100%; `;
const Brand = styled.div`
  display:flex; align-items:center; gap:9px; margin-bottom:14px;
  font-family:${({ theme }) => theme.font.display}; font-weight:800;
  font-size:${({ theme }) => theme.fontSize.lg}; color:${({ theme }) => theme.color.textPrimary};
`;
const GroupLabel = styled.div`
  margin:14px 0 4px; padding:0 12px; font-size:${({ theme }) => theme.fontSize.xs};
  color:${({ theme }) => theme.color.textMuted};
`;
const Row = styled(Link)<{ $active: boolean }>`
  display:flex; align-items:center; gap:10px; padding:10px 12px;
  border-radius:${({ theme }) => theme.radius.md}; text-decoration:none;
  font-size:${({ theme }) => theme.fontSize.sm};
  color:${({ theme, $active }) => ($active ? theme.color.textPrimary : theme.color.textMuted)};
  background:${({ theme, $active }) => ($active ? theme.color.glassBg : 'transparent')};
  &:hover { background:${({ theme }) => theme.color.glassBg}; color:${({ theme }) => theme.color.textPrimary}; }
  &:focus-visible { outline:2px solid ${({ theme }) => theme.color.focusRing}; outline-offset:-2px; }
`;

export function OwnerSidebar({ activeId }: { activeId: string }) {
  return (
    <Aside aria-label="Owner panel sections">
      <Brand><LogoTriad size={24} /> TruXSocial</Brand>
      <Row to="/owner" replace $active={activeId === 'dashboard'}
           aria-current={activeId === 'dashboard' ? 'page' : undefined}>
        <Icon name="home" size={18} /> Dashboard
      </Row>
      {OWNER_GROUPS.map((group) => (
        <div key={group.key}>
          <GroupLabel>{group.label}</GroupLabel>
          {OWNER_SECTIONS.filter((s) => s.group === group.key).map((s) => (
            <Row key={s.id} to={s.path} replace $active={s.id === activeId}
                 aria-current={s.id === activeId ? 'page' : undefined}>
              <Icon name={s.icon} size={18} /> {s.label}
            </Row>
          ))}
        </div>
      ))}
    </Aside>
  );
}
